$(document).ready(function () {
  function loadCartData(data) {
    var freeshipprc = $("cart-drawer.drawer.animate.active").attr(
      "freeShipping"
    );
    var itemIdToChecks = $(".add-git-to-cart").data("gift");
    var mineProperty = "";
    var idMine = $(".cart-items tbody tr").length;
    var cc = "";
    if (data.id == itemIdToChecks) {
      var cc = " giftCardMines";
    } else {
      var cc = "";
    }
    if (idMine) {
      idMine++;
      console.log(data.options_with_values);

      console.log($(".emptyMsg").length); // Should return 1 or more if the element exists

      $(".cart-items tbody").prepend(
        '<tr id="CartDrawer-Item-' +
          idMine +
          '" class="cart-item' +
          cc +
          '" role="row"><td class="cart-item__media" role="cell" headers="CartDrawer-ColumnProductImage"><a href="' +
          data.url +
          '" class="cart-item__link" tabindex="-1" aria-hidden="true"></a><img class="cart-item__image" src="' +
          data.image +
          '&width=300" alt="' +
          data.product_title +
          '" loading="lazy" width="150" height="150"></td><td class="cart-item__details" role="cell" headers="CartDrawer-ColumnProduct"><p class="caption-with-letter-spacing light">PuraU</p><a href="' +
          data.url +
          '" class="cart-item__name h4 break">' +
          data.product_title +
          '</a><dl><div class="product-option" dataMine="' +
          data.options_with_values[0].name +
          '"><dt>' +
          data.options_with_values[0].name +
          ":</dt><dd>" +
          data.options_with_values[0].value +
          '</dd></div></dl><ul class="discounts list-unstyled" role="list" aria-label="Discount"></ul> <div class=""><quantity-input class="quantity"><button class="quantity__button no-js-hidden" name="minus" type="button"><span class="visually-hidden">Decrease quantity for Inside &amp;amp; Out Gut Program</span><svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-minus" fill="none" viewBox="0 0 10 2"><path fill-rule="evenodd" clip-rule="evenodd" d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 110 1H1A.5.5 0 01.5 1z" fill="currentColor"></path></svg></button><input class="quantity__input" type="number" name="updates[]" value="1" min="0" aria-label="Quantity for Inside &amp;amp; Out Gut Program" id="Drawer-quantity-' +
          idMine +
          '" data-index="' +
          idMine +
          '"><button class="quantity__button no-js-hidden" name="plus" type="button"><span class="visually-hidden">Increase quantity for Inside &amp;amp; Out Gut Program</span><svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-plus" fill="none" viewBox="0 0 10 10"><path fill-rule="evenodd" clip-rule="evenodd" d="M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49.99a.5.5 0 00-1 .01v3.5l-3.5.01H1z" fill="currentColor"></path></svg></button></quantity-input></div></td><td class="cart-item__quantity" role="cell" headers="CartDrawer-ColumnQuantity"><div class="product-option">$' +
          (data.original_price / 100).toFixed(2) +
          '</div><div id="CartDrawer-LineItemError-' +
          idMine +
          '" class="cart-item__error" role="alert"><small class="cart-item__error-text"></small><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-error" viewBox="0 0 13 13"><circle cx="6.5" cy="6.50049" r="5.5" stroke="white" stroke-width="2"></circle><circle cx="6.5" cy="6.5" r="5.5" fill="#EB001B" stroke="#EB001B" stroke-width="0.7"></circle><path d="M5.87413 3.52832L5.97439 7.57216H7.02713L7.12739 3.52832H5.87413ZM6.50076 9.66091C6.88091 9.66091 7.18169 9.37267 7.18169 9.00504C7.18169 8.63742 6.88091 8.34917 6.50076 8.34917C6.12061 8.34917 5.81982 8.63742 5.81982 9.00504C5.81982 9.37267 6.12061 9.66091 6.50076 9.66091Z" fill="white"></path><path d="M5.87413 3.17832H5.51535L5.52424 3.537L5.6245 7.58083L5.63296 7.92216H5.97439H7.02713H7.36856L7.37702 7.58083L7.47728 3.537L7.48617 3.17832H7.12739H5.87413ZM6.50076 10.0109C7.06121 10.0109 7.5317 9.57872 7.5317 9.00504C7.5317 8.43137 7.06121 7.99918 6.50076 7.99918C5.94031 7.99918 5.46982 8.43137 5.46982 9.00504C5.46982 9.57872 5.94031 10.0109 6.50076 10.0109Z" fill="white" stroke="#EB001B" stroke-width="0.7"></path></svg></div><cart-remove-button id="CartDrawer-Remove-' +
          idMine +
          '" data-index="1"><button class="button button--tertiary" aria-label="Remove Intermediate Acne Program™">Remove</button></cart-remove-button></td></tr>'
      );
    } else {
      $(".emptyMsg").css("display", "none");
      $(".drawer").removeClass("is-empty");
      $("cart-drawer-items").removeClass("is-empty");
      $("#CartDrawer-CartItems").html(
        '<div class="drawer__cart-items-wrapper"><div class="top-cart-table"><table class="cart-items" role="table"><tbody role="rowgroup"><tr id="CartDrawer-Item-1" class="cart-item" role="row"><td class="cart-item__media" role="cell" headers="CartDrawer-ColumnProductImage"><a href="' +
          data.url +
          '" class="cart-item__link" tabindex="-1" aria-hidden="true"></a><img class="cart-item__image" src="' +
          data.image +
          '&width=300" alt="' +
          data.product_title +
          '" loading="lazy" width="150" height="150"></td><td class="cart-item__details" role="cell" headers="CartDrawer-ColumnProduct"><p class="caption-with-letter-spacing light">PuraU</p><a href="' +
          data.url +
          '" class="cart-item__name h4 break">' +
          data.product_title +
          '</a><dl><div class="product-option" dataMine="' +
          data.options_with_values[0].name +
          '"><dt>' +
          data.options_with_values[0].name +
          ":</dt><dd>" +
          data.options_with_values[0].value +
          '</dd></div></dl><p class="product-option"></p><ul class="discounts list-unstyled" role="list" aria-label="Discount"></ul><div class=""><quantity-input class="quantity"><button class="quantity__button no-js-hidden" name="minus" type="button"><span class="visually-hidden">Decrease quantity for Inside &amp;amp; Out Gut Program</span><svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-minus" fill="none" viewBox="0 0 10 2"><path fill-rule="evenodd" clip-rule="evenodd" d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 110 1H1A.5.5 0 01.5 1z" fill="currentColor"></path></svg></button><input class="quantity__input" type="number" name="updates[]" value="1" min="0" aria-label="Quantity for Inside &amp;amp; Out Gut Program" id="Drawer-quantity-1" data-index="1"><button class="quantity__button no-js-hidden" name="plus" type="button"><span class="visually-hidden">Increase quantity for Inside &amp;amp; Out Gut Program</span><svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-plus" fill="none" viewBox="0 0 10 10"><path fill-rule="evenodd" clip-rule="evenodd" d="M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49.99a.5.5 0 00-1 .01v3.5l-3.5.01H1z" fill="currentColor"></path></svg></button></quantity-input></div></td><td class="cart-item__quantity" role="cell" headers="CartDrawer-ColumnQuantity"><div class="product-option">$' +
          (data.original_price / 100).toFixed(2) +
          '</div><div id="CartDrawer-LineItemError-1" class="cart-item__error" role="alert"><small class="cart-item__error-text"></small><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-error" viewBox="0 0 13 13"><circle cx="6.5" cy="6.50049" r="5.5" stroke="white" stroke-width="2"></circle><circle cx="6.5" cy="6.5" r="5.5" fill="#EB001B" stroke="#EB001B" stroke-width="0.7"></circle><path d="M5.87413 3.52832L5.97439 7.57216H7.02713L7.12739 3.52832H5.87413ZM6.50076 9.66091C6.88091 9.66091 7.18169 9.37267 7.18169 9.00504C7.18169 8.63742 6.88091 8.34917 6.50076 8.34917C6.12061 8.34917 5.81982 8.63742 5.81982 9.00504C5.81982 9.37267 6.12061 9.66091 6.50076 9.66091Z" fill="white"></path><path d="M5.87413 3.17832H5.51535L5.52424 3.537L5.6245 7.58083L5.63296 7.92216H5.97439H7.02713H7.36856L7.37702 7.58083L7.47728 3.537L7.48617 3.17832H7.12739H5.87413ZM6.50076 10.0109C7.06121 10.0109 7.5317 9.57872 7.5317 9.00504C7.5317 8.43137 7.06121 7.99918 6.50076 7.99918C5.94031 7.99918 5.46982 8.43137 5.46982 9.00504C5.46982 9.57872 5.94031 10.0109 6.50076 10.0109Z" fill="white" stroke="#EB001B" stroke-width="0.7"></path></svg></div><cart-remove-button id="CartDrawer-Remove-' +
          idMine +
          '" data-index="1"><button class="button button--tertiary" aria-label="Remove Intermediate Acne Program™">Remove</button></cart-remove-button></td></tr></tbody></table></div></div>'
      );
    }
    $("body").removeClass("push-left-new");
    $(".title_upsell").addClass("hide");
    $(".mini-cart-product").remove();
    $("body").addClass("overflow-hidden");
    $("cart-drawer").addClass("animate active");
    $(".cart-items tbody tr").each(function (index) {
      index++;
      $(this).attr("id", "CartDrawer-Item-" + index);
      $(this)
        .find(".quantity__input")
        .attr("id", "Drawer-quantity-" + index);
      $(this).find(".quantity__input").attr("data-index", index);
      $(this).find("cart-remove-button").attr("data-index", index); // Update data-index for cart-remove-button
    });
    fetch("/cart.js")
      .then((response) => response.json())
      .then((data) => {
        $(".cart-count-bubble span").text(data.item_count);
        console.log(data.item_count);
        // console.log(data.brace);
        $("span.cart_count").text(data.brace);
        var minePrice = data.total_price / 100;
        $("#CartDrawer-Checkout").html("CHECKOUT - $" + minePrice + " AUD");
        $("#CartDrawer-Checkout").removeAttr("disabled");
        calculateProgress(data.total_price, freeshipprc);
        var minePrice = data.total_price / 100;
        var afterpayPrice = (minePrice / 4).toFixed(2);
        $(".cart-drawer__footer .totals__subtotal-value").html(
          "&nbsp;$" + minePrice + " AUD"
        );
        $(".afterpay").html("$" + afterpayPrice + " AUD");
      });
  }

  var variantDropdown = $("#variant_id");
  var addButton = $(".add-git-to-cart");

  $("body").on("change", "#variant_id", function () {
    var selectedFlavor = $(this).val();

    if (selectedFlavor != "-1") {
      $(".add-git-to-cart").removeAttr("disabled");
      $(".add-git-to-cart").attr("data-attr", selectedFlavor);
    } else {
      $(".add-git-to-cart").attr("disabled", "disabled");
      $(".add-git-to-cart").attr("data-attr", "");
    }
  });

  // When any dropdown menu changes
  /*$('select').change(function() {   
    var selectedVariantId = $(this).find(':selected').val(); // Get the selected option value (which is variant ID)
    $('.add-git-to-cart').attr('data-attr', selectedVariantId); // Set data-attr attribute of the anchor tag
  });*/

  // $('body').on('click', '.choco_add_to_cart', function(event) {
  //   event.preventDefault();

  //   var quantity = $('.pack-button.active').data('quantity');
  //   var variantId = $(this).data('variantid');

  //   // Debugging log
  //   console.log('Quantity to add:', quantity);

  //   // Make the AJAX request to add the item to the cart
  //   $.ajax({
  //     type: 'POST',
  //     url: '/cart/add.js',
  //     data: {
  //       quantity: quantity,
  //       id: variantId
  //     },
  //     dataType: 'json',
  //     success: function(response) {
  //       loadCartData(response);
  //     },
  //     error: function(error) {
  //       console.log('Error updating cart:', error);
  //     }
  //   });
  // });
  $("body").on("click", ".product-list .add-to-btn", function (event) {
    //alert('test');
    event.preventDefault();
    var productId = $(this).attr("data-mine");

    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: {
        quantity: 1, // You can adjust the quantity if needed
        id: productId,
      },
      dataType: "json",
      success: function (response) {
        console.log("Product added to cart successfully:", response);
        loadCartData(response);
      },
      error: function (error) {
        console.error("Error adding product to cart:", error);
      },
    });
  });
  $("body").on("click", ".col-prod-product-atc-but", function (event) {
    //alert('test');
    event.preventDefault();
    var productId = $(this).attr("data-mine");

    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: {
        quantity: 1,
        id: productId,
      },
      dataType: "json",
      success: function (response) {
        console.log("Product added to cart successfully:", response);
        loadCartData(response);
      },
      error: function (error) {
        console.error("Error adding product to cart:", error);
      },
    });
  });
  $("body").on("click", ".giftcart-info .add-git-to-cart", function (event) {
    //alert('test');
    event.preventDefault();
    var productId = $(this).attr("data-attr");

    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: {
        quantity: 1, // You can adjust the quantity if needed
        id: productId,
      },
      dataType: "json",
      success: function (response) {
        console.log("Product added to cart successfully:", response);
        loadCartData(response);
      },
      error: function (error) {
        console.error("Error adding product to cart:", error);
      },
    });
  });
});

jQuery(document).ready(function ($) {
  var url = window.location.href;
  if (url.indexOf("?collectionName") > -1) {
    var collectionName = url.split("collectionName=")[1];
    $("a.tab").removeClass("selected");
    $('a.tab[title-data="' + collectionName + '"]').addClass("selected");
    var dataMine = $('a.tab[title-data="' + collectionName + '"]').attr(
      "data-toggle-target"
    );
    $(".tab-content").removeClass("active");
    $(dataMine).addClass("active");
  }

  setTimeout(function () {
    // $('.videoMine')[0].contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');
  }, 5000);

  // Repair product slider start.
  $(".restore-slider-wrapper").slick({
    lazyLoad: "ondemand",
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: true,
    infinite: true,
    prevArrow:
      '<button class="slick-prev slick-arrow"><img src="https://cdn.shopify.com/s/files/1/0342/9839/6811/files/new-left-arrow.png?v=1654691620"></button>',
    nextArrow:
      '<button class="slick-next slick-arrow"><img src="https://cdn.shopify.com/s/files/1/0342/9839/6811/files/new-right-arrow.png?v=1654691620"></button>',
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          dots: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          dots: true,
        },
      },
      {
        breakpoint: 481,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          dots: true,
        },
      },
    ],
  });

  // Repair product slider end.

  // for home collection section
  // $('.home-coll-list-product').slick({
  //   dots: true,
  //   infinite: true,
  //   speed: 500,
  //   slidesToShow: 4,
  //   slidesToScroll: 1,
  //   autoplay: false,
  //   autoplaySpeed: 2000,
  //   arrows: true,
  //   mobileFirst: true,
  //         responsive: [
  //     {
  //       breakpoint: 1024,
  //       settings: {
  //         slidesToShow: 4,
  //         slidesToScroll: 1,
  //         infinite: true,
  //         dots: false
  //       }
  //     },
  //     {
  //       breakpoint: 768,
  //       settings: {
  //         slidesToShow: 3,
  //         slidesToScroll: 1,
  //         infinite: true,
  //         dots: false
  //       }
  //     },
  //     {
  //       breakpoint: 600,
  //       settings: {
  //         slidesToShow: 2,
  //         slidesToScroll: 1,
  //         infinite: true,
  //         dots: false
  //       }
  //     },
  //     {
  //       breakpoint: 480,
  //       settings: {
  //         slidesToShow: 2,
  //         slidesToScroll: 1,
  //         infinite: true,
  //         dots: false
  //       }
  //     }
  //   ]
  // });

  // for home product ban three

  // $('.product-three-left').slick({
  //   dots: false,
  //   infinite: true,
  //   speed: 500,
  //   slidesToShow: 1,
  //   slidesToScroll: 1,
  //   autoplay: false,
  //   autoplaySpeed: 2000,
  //   arrows: true,
  //   prevArrow: $('.cust-prev'),
  //   nextArrow: $('.cust-next'),
  //   responsive: [{
  //     breakpoint: 600,
  //     settings: {
  //       slidesToShow: 1,
  //       slidesToScroll: 1
  //     }
  //   },
  //                {
  //                  breakpoint: 480,
  //                  settings: {
  //                    arrows: false,
  //                    slidesToShow: 1,
  //                    slidesToScroll: 1
  //                  }
  //                }]
  // });

  // for home collection range

  // $('.home-coll-range-wrapper').slick({
  //   dots: true,
  //   infinite: true,
  //   speed: 500,
  //   slidesToShow: 5,
  //   slidesToScroll: 1,
  //   autoplay: false,
  //   autoplaySpeed: 2000,
  //   centerMode: true,
  //   centerPadding: '60px',
  //   arrows: true,
  //   mobileFirst: true,
  //   responsive: [
  //     {
  //     breakpoint: 1024,
  //     settings: {
  //       dots: false,
  //       arrows: false,
  //       slidesToShow: 4,
  //       slidesToScroll: 1
  //     }
  //   },
  //     {
  //     breakpoint: 768,
  //     settings: {
  //       slidesToShow: 3,
  //       slidesToScroll: 1
  //     }
  //   },
  //                {
  //                  breakpoint: 600,
  //                  settings: {
  //                    arrows: false,
  //                    slidesToShow: 2,
  //                    slidesToScroll: 1
  //                  }
  //                },
  //                  {
  //                  breakpoint: 480,
  //                  settings: {
  //                    arrows: false,
  //                    slidesToShow: 1,
  //                    slidesToScroll: 1
  //                  }
  //                }]
  // });

  // for Faq
  $(".panel").hide();
  $("body").on("click", ".accordion", function () {
    $(this).parents(".Question").find(".panel").toggle();
    $(this).parents(".Question").find(".accordion").toggleClass("on");
  });

  // for footer Faq
  $(".foo-panel").hide();
  $("body").on("click", ".foo-accordion ", function () {
    $(this).parents(".footer-block-mobile").find(".foo-panel").toggle();
    $(this)
      .parents(".footer-block-mobile")
      .find(".foo-accordion ")
      .toggleClass("on-footer");
  });

  // for variant popup
  // $('body').on('click', '.quest-pop', function(){
  //   if($(this).parents('.ques-pop-main').find('.ques-pop-answer').hasClass('hide')){
  //     $('.ques-pop-answer').addClass('hide');
  //     $(this).parents('.ques-pop-main').find('.ques-pop-answer').removeClass('hide');
  //   }else{
  //     $(this).parents('.ques-pop-main').find('.ques-pop-answer').addClass('hide');
  //   }
  //   $(this).parents('.ques-pop-main').find('.quest-pop').toggleClass("on-pop");
  //   $(".gradient").toggleClass("pop-UP");
  // });

  // $(".ques-pop-inner").focusout(function(){
  //   $('.ques-pop-inner').addClass('hide');
  // });

  // $("#myBtn1").click(function() {
  //   $("#myModal").hide();
  // });
  // $("#myBtn").click(function() {
  //   $("#myModal1").hide();
  // });
  // $("#myBtn2").click(function() {
  //   $("#myModal2").hide();
  // });

  // for collection tabbing.
  $(function () {
    $(".tabs .tabs-inner a").on("click", function () {
      show_content($(this).index());
    });

    function show_content(index) {
      // Make the content visible
      $(".tabs .content.visible").removeClass("visible");
      $(".tabs .content:nth-of-type(" + (index + 1) + ")").addClass("visible");

      // Set the tab to selected
      $(".tabs .tabs-inner a.selected").removeClass("selected");
      $(".tabs .tabs-inner a:nth-of-type(" + (index + 1) + ")").addClass(
        "selected"
      );
    }
  });

  // for product page slider

  //     $('.product_page-slide').slick({
  //   dots: true,
  //   infinite: true,
  //   speed: 500,
  //   slidesToShow: 1,
  //   slidesToScroll: 1,
  //   autoplay: false,
  //   autoplaySpeed: 2000,
  //   arrows: true,
  //   responsive: [{
  //     breakpoint: 600,
  //     settings: {
  //       slidesToShow: 1,
  //       slidesToScroll: 1
  //     }
  //   },
  //                {
  //                  breakpoint: 480,
  //                  settings: {
  //                    arrows: false,
  //                    slidesToShow: 1,
  //                    slidesToScroll: 1
  //                  }
  //                }]
  // });

  // home logos slider for mobile

  //     $('.home-logos-mobile').slick({
  //   dots: false,
  //   infinite: true,
  //   speed: 500,
  //   slidesToShow: 4,
  //   slidesToScroll: 1,
  //   autoplay: false,
  //   autoplaySpeed: 2000,
  //   arrows: true,
  //   responsive: [{
  //     breakpoint: 600,
  //     settings: {
  //       dots: false,
  //       slidesToShow: 4,
  //       slidesToScroll: 1
  //     }
  //   },
  //                {
  //                  breakpoint: 400,
  //                  settings: {
  //                    dots: false,
  //                    arrows: false,
  //                    slidesToShow: 4,
  //                    slidesToScroll: 1
  //                  }
  //                }]
  // });

  // home product slider for mobile

  // $('.home-product-wrapper-mob').slick({
  //   dots: false,
  //   infinite: true,
  //   speed: 500,
  //   slidesToShow: 5,
  //   slidesToScroll: 1,
  //   autoplay: false,
  //   autoplaySpeed: 2000,
  //   centerMode: true,
  //   centerPadding: '60px',
  //   arrows: true,
  //   mobileFirst: true,
  //   responsive: [{
  //     breakpoint: 768,
  //     settings: {
  //       dots: false,
  //       slidesToShow: 1,
  //       slidesToScroll: 1
  //     }
  //   },
  //                {
  //                  breakpoint: 600,
  //                  settings: {
  //                    dots: false,
  //                    arrows: false,
  //                    slidesToShow: 1,
  //                    slidesToScroll: 1
  //                  }
  //                }]
  // });

  // home text and logos slider for mobile

  // $('.home-text-logos-mob').slick({
  //   dots: false,
  //   infinite: true,
  //   speed: 300,
  //   slidesToShow: 1,
  //   slidesToScroll: 1,
  //   autoplay: true,
  //   arrows: true,
  //   responsive: [{
  //     breakpoint: 768,
  //     settings: {
  //       dots: false,
  //       slidesToShow: 1,
  //       slidesToScroll: 1
  //     }
  //   },
  //                {
  //                  breakpoint: 600,
  //                  settings: {
  //                    dots: true,
  //                    arrows: false,
  //                    slidesToShow: 1,
  //                    slidesToScroll: 1
  //                  }
  //                },
  //                   {
  //                  breakpoint: 480,
  //                  settings: {
  //                    dots: true,
  //                    arrows: false,
  //                    slidesToShow: 1,
  //                    slidesToScroll: 1
  //                  }
  //                }]
  // });

  // home text and logos slider for mobile

  $(".shop-need-product-mob").slick({
    dots: true,
    infinite: true,
    speed: 800,
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 2000,
    arrows: false,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          dots: true,
          arrows: false,
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          dots: true,
          arrows: false,
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          dots: true,
          arrows: false,
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 0,
        settings: {
          dots: true,
          arrows: false,
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
  });
});
$(function () {
  if (
    navigator.userAgent.indexOf("Safari") != -1 &&
    navigator.userAgent.indexOf("Chrome") == -1
  ) {
    $("body").addClass("safari-mac");
  }
});

document.addEventListener('DOMContentLoaded', function () {
  const videoWrappers = document.querySelectorAll('.pdp-video');
  
  videoWrappers.forEach(function (wrapper) {
    const video = wrapper.querySelector('video');
    const controls = wrapper.querySelector('.controls');
    const pushBtn = controls.querySelector('.push_video');
    const playBtn = controls.querySelector('.play_video');
    video.volume = 1;
    video.muted = false;
    controls.addEventListener('click', function () {
      console.log('click')
      if (video.paused) {
        video.play();
        video.volume = 1;
        pushBtn.style.display = 'none';
        playBtn.style.display = 'inline-block';
      } else {
        video.pause();
         video.volume = 0;
        pushBtn.style.display = 'inline-block';
        playBtn.style.display = 'none';
      }
    });
  });

  document.querySelectorAll('.video_triger').forEach(function(poster) {
      poster.addEventListener('click', function() {
          const nextDiv = this.nextElementSibling;
          if (nextDiv) {
              nextDiv.classList.add('active');
          }
      });
  });
  document.querySelectorAll('.pdp-video_popuClose').forEach(function(close) {
      close.addEventListener('click', function() {
          const parentDiv = this.closest('.pdp-video');
          const parentVideo = parentDiv.querySelector('video');
          const pushBtn1 = parentDiv.querySelector('.push_video');
          const playBtn1 = parentDiv.querySelector('.play_video');
          
          if (parentDiv) {
              parentDiv.classList.remove('active');
          }
          if (parentVideo) {
              parentVideo.pause();
              pushBtn1.style.display = 'inline-block';
              playBtn1.style.display = 'none';
          }
      });
  });

  document.querySelectorAll('.discount_timeCopy_button').forEach(function(button) {
    button.addEventListener('click', () => {
      const container = button.parentElement;
      const textElement = container.querySelector('.discount_result_timeCopy');
      if (textElement) {
        const textToCopy = textElement.textContent.trim();
        navigator.clipboard.writeText(textToCopy)
          .then(() => {
            console.log('Copied to clipboard:', textToCopy);
          })
          .catch(err => { 
            console.error('Failed to copy:', err);
          });
      }
    });
  });

   

});

